export default "__VITE_ASSET__c290bd99__"